import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="16">
    <path d="M12 2.667H9.333a2.667 2.667 0 00-5.333 0H1.333A1.337 1.337 0 000 4v10.667A1.337 1.337 0 001.333 16H12a1.337 1.337 0 001.333-1.333V4A1.337 1.337 0 0012 2.667zM6.667 1.333a1.333 1.333 0 11-1.334 1.334 1.333 1.333 0 011.334-1.334zm2.555 6.779l-3.037 4.555-2.555-1.7a.667.667 0 11.74-1.109l1.445.963 2.3-3.445a.667.667 0 011.109.74z" />
  </svg>
);
